"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../utils");

var evaluateScene_1 = require("./evaluateScene");

var evaluateStringVariable_1 = require("./evaluateStringVariable");

var evaluateStyle_1 = require("./evaluateStyle");

var evaluateSubtitleOptions_1 = require("./evaluateSubtitleOptions");

var evaluateControlOptions_1 = require("./evaluateControlOptions");

exports.evaluateTemplate = function (template, variableDictionary) {
  var value = {
    autoPlay: template.autoPlay,
    content: template.content,
    defaultSceneId: evaluateStringVariable_1.evaluateStringVariable(template.defaultSceneId, variableDictionary),
    scenes: template.scenes.map(function (scene) {
      return evaluateScene_1.evaluateScene(scene, variableDictionary);
    }),
    subtitleOptions: evaluateSubtitleOptions_1.evaluateSubtitleOptions(template.subtitleOptions, variableDictionary),
    controlOptions: evaluateControlOptions_1.evaluateControlOptions(template.controlOptions, variableDictionary)
  };
  if (utils_1.hasValue(template.poster)) value.poster = evaluateStringVariable_1.evaluateStringVariable(template.poster, variableDictionary);
  if (utils_1.hasValue(template.style)) value.style = evaluateStyle_1.evaluateStyle(template.style, variableDictionary);
  return value;
};